import { useQuery } from "@tanstack/react-query";
import { useCompanyAxis } from "@/api/use-company-context";
import { useSessionScope } from "@/auth/use-session-scope";
import { authority } from "./api";
export type PolicyAuthority = Awaited<ReturnType<typeof authority>>;
export const canOpenPolicyManagement = (value: PolicyAuthority | undefined): boolean => value?.companies.some(company => company.actions.includes("read")) === true;
export const canOpenMyPolicies = (value: PolicyAuthority | undefined): boolean => value?.can_read_self === true;
export function usePolicyAuthority({ enabled = true }: { enabled?: boolean } = {}) {
  const scope = useSessionScope(); const company = useCompanyAxis();
  return useQuery({ queryKey: ["policy-authority", ...scope, company.active_legal_entity_id], queryFn: authority, enabled, staleTime: 60_000 });
}
